import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-app-origination-list-dialog',
    templateUrl: './app-origination-list-dialog.component.html',
    styleUrls: ['./app-origination-list-dialog.component.scss']
})
export class AppOriginationListDialogComponent implements OnInit {
    origination: any;
    filteredApps: any[];

    constructor(public matDialogRef: MatDialogRef<AppOriginationListDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {
    }

    ngOnInit(): void {
        this.origination = this.data.origination;
        this.filteredApps = this.data.filteredApps;
    }

    goToStartupDetail(app: any) {

    }
}
